var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 1.5C4.83579 1.5 4.5 1.83579 4.5 2.25V21.75C4.5 22.1642 4.83579 22.5 5.25 22.5H9.75C10.1642 22.5 10.5 22.1642 10.5 21.75V2.25C10.5 1.83579 10.1642 1.5 9.75 1.5H5.25ZM9 3H6V21H9V3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.25 1.5C13.8358 1.5 13.5 1.83579 13.5 2.25V21.75C13.5 22.1642 13.8358 22.5 14.25 22.5H18.75C19.1642 22.5 19.5 22.1642 19.5 21.75V2.25C19.5 1.83579 19.1642 1.5 18.75 1.5H14.25ZM18 3H15V21H18V3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause.9bc96e52aebbb10dcfe93c91df392e5f.svg";